import React from "react";
import loaderImage from '../media/images/CabanaLoader.gif';


export const Loader = (): JSX.Element => {
    return (
        <div className="LoaderContainer">
            <img
                src={loaderImage}
                alt="loader"
            />
        </div>
    )
}